import { ServerClient } from 'common/utils/http/http-clients';
import { ITrafficReportRead } from './traffic-report.service.types';
import { IResponseList } from 'common/models/response-list.interface';

class TrafficReportService {
  async getAll(): Promise<IResponseList<ITrafficReportRead>> {
    const res = await ServerClient.get<IResponseList<ITrafficReportRead>>(`/traffic-log-reports`);
    return res?.data;
  }

  async create(body: any): Promise<any> {
    const res = await ServerClient.post<any>('/traffic-log-reports', body);
    return res?.data;
  }

  async delete(id: number): Promise<any> {
    const res = await ServerClient.delete<any>(`/traffic-log-reports/${id}`);
    return res?.data;
  }
}

export const trafficReportService = new TrafficReportService();
export default trafficReportService;
